<ng-container
  *ngComponentOutlet="iconComponent()!; inputs: { stroke: stroke(), width: width(), height: height() }">
</ng-container>
